<template>
  <div>
    <div v-if="!countryFilterActive" class="ranking">
      <header class="card-header">
        <p class="card-header-title">
          {{ "charts.topComparedItems" | t }}
        </p>
      </header>
      <div class="card-content">
        <Top10Chart class="content-body" :top10Data="chartData.data" />
      </div>
    </div>
    <VsNoChartData v-else height="290px" withButton>
      <template v-slot:errorMessage>
        <p>{{ "charts.errorMessage.productFilterError" | t }}</p>
      </template>
    </VsNoChartData>
  </div>
</template>

<script>
import Top10Chart from "./Top10Chart";
import { mapGetters } from "vuex";

export default {
  components: {
    Top10Chart,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeFilters: "filters/getAllActiveFilters",
    }),
    countryFilterActive() {
      return this.activeFilters?.countries?.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.ranking {
  height: 100%;

  .card-header-title {
    padding-left: 20px;
    font-weight: 400;
    font-size: 16px;
  }

  .coming-soon {
    padding-top: 55px;
    color: $primary;
    font-weight: 700;
    font-size: 40px;
    text-align: center;
  }

  .card-content {
    height: 230px;
    padding: 4px;
    overflow-y: auto;
  }
}
</style>
